export default function ArrowsIcon() {
  return (
    <svg
      width="16px"
      height="26px"
      viewBox="0 0 16 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Group 2</title>
      <g
        id="Admin-tool"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Admin-Role-Switcher-Open"
          transform="translate(-1381.000000, -19.000000)"
        >
          <g id="Group-2" transform="translate(1381.000000, 19.000000)">
            <g id="Group" transform="translate(0.000000, 10.000000)">
              <g
                id="Icon/Arrow-iOS-Forward"
                transform="translate(8.000000, 8.000000) rotate(90.000000) translate(-8.000000, -8.000000) "
              >
                <polygon
                  id="24pt-Bounding-Box"
                  opacity="0"
                  fillRule="nonzero"
                  transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
                  points="0 0 16 0 16 16 0 16"
                ></polygon>
                <path
                  d="M6.66666667,12.6666667 L6.66666666,12.6666667 C6.51089866,12.666971 6.35994132,12.6127207 6.23999999,12.5133333 L6.23999992,12.5133333 C5.95655325,12.2783399 5.91727458,11.8580613 6.15226792,11.5746133 C6.15262249,11.5741856 6.15297761,11.5737583 6.15333326,11.5733315 L9.13999992,7.99999821 L6.25999992,4.41999821 L6.25999989,4.41999816 C6.02789455,4.13418216 6.07143522,3.71432483 6.35725122,3.48221816 C6.3581655,3.48147569 6.35908175,3.48073564 6.35999995,3.47999803 L6.35999994,3.47999804 C6.63642327,3.23678204 7.05767327,3.26370138 7.3008866,3.54012471 C7.31220967,3.55299378 7.32303227,3.56629478 7.33333014,3.57999804 L10.5533301,7.57999804 L10.5533302,7.57999806 C10.7555415,7.82599939 10.7555415,8.18066339 10.5533301,8.42666473 L7.21999679,12.4266647 L7.21999681,12.4266647 C7.08435481,12.5902954 6.87882014,12.6794434 6.66666348,12.6666647 L6.66666667,12.6666667 Z" //NOSONAR
                  id="Fill"
                  fill="#6F747E"
                ></path>
              </g>
            </g>
            <g
              id="Icon/Arrow-iOS-Forward"
              transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
            >
              <polygon
                id="24pt-Bounding-Box"
                opacity="0"
                fillRule="nonzero"
                transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
                points="0 0 16 0 16 16 0 16"
              ></polygon>
              <path
                d="M6.66666667,12.6666667 L6.66666666,12.6666667 C6.51089866,12.666971 6.35994132,12.6127207 6.23999999,12.5133333 L6.23999992,12.5133333 C5.95655325,12.2783399 5.91727458,11.8580613 6.15226792,11.5746133 C6.15262249,11.5741856 6.15297761,11.5737583 6.15333326,11.5733315 L9.13999992,7.99999821 L6.25999992,4.41999821 L6.25999989,4.41999816 C6.02789455,4.13418216 6.07143522,3.71432483 6.35725122,3.48221816 C6.3581655,3.48147569 6.35908175,3.48073564 6.35999995,3.47999803 L6.35999994,3.47999804 C6.63642327,3.23678204 7.05767327,3.26370138 7.3008866,3.54012471 C7.31220967,3.55299378 7.32303227,3.56629478 7.33333014,3.57999804 L10.5533301,7.57999804 L10.5533302,7.57999806 C10.7555415,7.82599939 10.7555415,8.18066339 10.5533301,8.42666473 L7.21999679,12.4266647 L7.21999681,12.4266647 C7.08435481,12.5902954 6.87882014,12.6794434 6.66666348,12.6666647 L6.66666667,12.6666667 Z" //NOSONAR
                id="Fill"
                fill="#6F747E"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
